import retry from '@/utils/retry';
import {MESSAGES} from '../uitls/messages';
import {notifyError} from '../uitls/notification-helper';
import redirect from '../uitls/redirect';
import eliteService from './../api/elite-service';

const getState = () => {
    return {
        tenantData: null,
        videoList: [],
        trainerDataLoading: false,
        displayVideosCount: 4,
        startIndex: -4,
        videoToDisplay: null,
        hideNextButton: false,
        hidePrevButton: false,
        videoCount: null,
        profileVideo: null,
        isAccessCodeCancel: sessionStorage.getItem('isAccessCodeCancel') === 'true',
    };
}
const state = getState();

const mutations = {
    setTenant(state, data) {
        state.tenantData = data
    },

    setLoading(state, data) {
        state.trainerDataLoading = data
    },

    setVideos(state, data) {
        const comingSoonVideos = data.filter((video) => video.isUpcoming);
        const videos = data.filter((video) => !video.isUpcoming);
        state.videoList = [...videos, ...comingSoonVideos];
    },

    setVideoCount(state, count) {
        state.videoCount = count;
    },

    setProfileVideo(state, video) {
        state.profileVideo = video;
    },

    setIndex(state, dir) {
        state.hidePrevButton = false;
        state.hideNextButton = false;
        state.startIndex = (dir == "prev") ? state.startIndex - state.displayVideosCount : state.startIndex + state.displayVideosCount;
        let videos = state.videoList;
        if (videos.length < 4) {
            state.videoToDisplay = videos;
            state.hidePrevButton = true;
            state.hideNextButton = true;
            return;
        }

        if (state.startIndex + state.displayVideosCount > videos.length) {
            state.startIndex = videos.length - state.startIndex;
        }
        if (state.startIndex < 1) {
            state.startIndex = 0;
            state.hidePrevButton = true;
        }
        if (state.startIndex > -1) {
            state.videoToDisplay = videos.splice(state.startIndex, state.displayVideosCount);
        }
        if (state.startIndex >= state.videoList.length) {
            state.hideNextButton = true;
        }
    },
    setIsAccessCodeCancel(state, isAccessCodeCancel){
        state.isAccessCodeCancel = isAccessCodeCancel;
    }
};

const getters = {

};

const actions = {
    async loadTenantData({ commit }, tenantName) {
        commit('setLoading', true);
        try {
            const data = await eliteService.getTenantData(tenantName);
            commit('setTenant', data);
            commit('setLoading', false);
            return data;
        }
        catch (e) {
            try {
                await retry(e);
                const data = await eliteService.getTenantData(tenantName);
                commit('setTenant', data);
                commit('setLoading', false);
                return data;
            } catch{
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
        };
    },

    async getVideos({ commit }) {
        try {
            const data = await eliteService.getTenantVideos(state.tenantData.id);
            commit('setVideoCount', data.length);
            commit('setVideos', data);
            commit('setProfileVideo', data[0]);
            return data;
        }
        catch (e) {

            try {
                const data = await eliteService.getTenantVideos(state.tenantData.id);
                commit('setVideoCount', data.length);
                commit('setVideos', data);
                commit('setProfileVideo', data[0]);
                return data;
            } catch{
                redirect(e);
                notifyError(MESSAGES.LOAD_VIDEO_FAILED);
                Promise.reject(e);
            }
        }
    },

    setIndex({ commit }, dir) {
        commit('setIndex', dir);
    },
    setIsAccessCodeCancel({commit }, isAccessCodeCancel) {
        sessionStorage.setItem("isAccessCodeCancel", isAccessCodeCancel)
        commit("setIsAccessCodeCancel", isAccessCodeCancel);
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
